import { v5 } from 'uuid';
import type { Payment, PaymentDuration } from '@//app/api/commerce/payments/[id]/list';
import type { ModifyPaymentVariables, PaymentWithId } from '@//data/ecom/useModifyPayment';

export interface PaymentForm {
  payment: PaymentWithId;
}

export const createDefaultValues = (payment: PaymentWithId) => ({
  payment: structuredClone(payment),
});

export const createIndexedPayments = (payments: Payment[]): PaymentWithId[] =>
  payments.map((payment) => {
    const id = v5(JSON.stringify(payment), v5.DNS);
    return {
      ...payment,
      generatedId: id,
    };
  });

export const createDurationSteps = (duration: PaymentDuration) => {
  const { min, max, step } = duration;
  if (min == null || max == null || step == null) return [];
  return Array.from({ length: Math.floor((max - min) / step) + 1 }, (_, i) => min + i * step);
};

export const createModifiedPayload = (
  id: string,
  branchId: string,
  payment: PaymentWithId,
): ModifyPaymentVariables | undefined => {
  if (Number.isNaN(payment.downPayment.current)) {
    return undefined;
  }
  if (Number.isNaN(payment.duration.current)) {
    return undefined;
  }

  return {
    id,
    body: {
      generatedId: payment.generatedId,
      branchId,
      downPayment: parseInt(payment.downPayment.current.toFixed(0), 10),
      duration: parseInt(payment.duration.current.toFixed(0), 10),
      residual: payment.residual ? payment.residual.current / 100 : undefined,
      financialOptionId: payment.financialOptionId,
    },
  };
};
